import moment from "moment";
import XLSX from "xlsx";
import { store } from "../redux/store";

const fs = require("fs");

export const thousandSeparator = (number) => {
    let parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(",");
};

export const formatNumberComma = (number, after = 2) => {
    let num = parseFloat(number);
    if (num === 0) return 0;

    return num.toFixed(after).replace(/\.?0+$/, "");
};

export const isImageFile = (filename) => {
    const extention = getExtentionFile(filename);
    return /(jpe?g|jpg|png|gif|bmp)$/i.test(extention);
};

export const getExtentionFile = (filename) => {
    return (filename.match(/\.([^.]*?)(?=\?|#|$)/) || [])[1];
};

export const isArrayOfFiles = (document) => typeof document == "object";

export const getFileToShow = (document) => (isArrayOfFiles(document) ? document[0].url : document);

export const validateFile = (filetype) => {
    let valid = false;
    const splitFile = filetype.split("/");
    if (/(jpe?g|jpg|png|gif|bmp)$/i.test(splitFile[1])) {
        valid = true;
    } else if (/(pdf)$/i.test(splitFile[1])) {
        valid = true;
    }
    return valid;
};

export const loanStatus = (id) => {
    let status = "";
    switch (id) {
        case 1:
            status = "Draf";
            break;
        case 2:
            status = "Underwriting";
            break;
        case 3:
            status = "Pre-Fund";
            break;
        case 4:
            status = "Approve";
            break;
        case 5:
            status = "Active";
            break;
        case 6:
            status = "Closed";
            break;
        case 7:
            status = "Cancelled";
            break;
        case 8:
            status = "Declined";
            break;
        default:
            status = "";
    }
    return status;
};

export const exportToExcel = (data) => {
    let fileFormat = ".xlsx";
    let result = [];
    let temp = [];
    let tempHead = [];
    for (let count = 0; count < data.length; count++) {
        temp = [];
        for (let prop in data[count]) {
            if (count === 0) {
                temp.push(data[count][prop]);
                tempHead.push(prop);
            } else {
                temp.push(data[count][prop]);
            }
        }
        if (count === 0) {
            result.push(tempHead);
            result.push(temp);
        } else {
            result.push(temp);
        }
    }
    const worksheet = XLSX.utils.aoa_to_sheet(result);
    let newWorkbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(newWorkbook, worksheet, "Sheet");
    XLSX.writeFile(newWorkbook, "export" + Date.now() + fileFormat);
};

export const isLastRow = (index, totalPage) => {
    return index === totalPage - 1;
};

export const productIdentifier = (productId) => {
    let endpoint = "";
    switch (productId) {
        case "570f91ea-412b-11eb-99d9-00163e01a609":
            endpoint = "/tokutei_gino_loan";
            break;
        case "19a80828-ec60-11ec-8431-00163e01a609":
            endpoint = "/trainee_loan";
            break;
        case "35831e74-408a-11ed-8ab8-00163e01a609":
            endpoint = "/advance_disburse";
            break;
        case "a4475b08-9261-11ed-80ef-00163e01a609":
            endpoint = "/farmer_loan";
            break;
        case "7df01b94-a95b-11ef-b4c8-00163e03550e":
            endpoint = "/daya_solusi";
            break;
        case "784b95d8-9912-4f38-a674-ac77d6507dc0":
            endpoint = "/korea_p2p"
            break;
        case "b1d57ed6-0fe8-457c-872f-d27575057b04":
            endpoint = "/korea_g2g"
            break;
        default:
            endpoint = "/education_loan";
    }
    return endpoint;
};

export const isProductTokutei = (productId) => {
    return productId === "570f91ea-412b-11eb-99d9-00163e01a609";
};

export const isoToDate = (value) => {
    return moment(value).format("yyyy-MM-DD");
};
export const DateToIso = (value) => {
    return moment(value).toISOString();
};

// export const checkDisabledEditMenu = (user, menu) => {
//   let { activatedMenuItemIds, menuItems } = menu;
//   let { user_admin_access } = user;

//   let findMenu = menuItems.find((item) => item.id === activatedMenuItemIds[0]);
//   let checkDisabled = user_admin_access.find(
//     (item) => item.menu_access === findMenu?.menu_id
//   );
//   return checkDisabled.disabled_edit;
// };

const roleIdentifier = (role_id) => {
    switch (role_id) {
        case "80e5ff74-063c-11eb-8c5f-00163e01a609":
            return "super_admin";

        case "c26d70b6-79cc-11ed-b20b-00163e01a609":
            return "credit";

        case "56d248f4-a95f-11ee-97a6-00163e01a609":
            return "credit_manager";

        case "578ae382-c46f-11f0-af86-00163e01a609":
            return "administrative_services_specialist";

        default:
            return null;
    }
};

export const checkRoleAccess = (user, roles) => {
    const { user_role_map } = user;
    const { role_id } = Object.values(user_role_map)[0];

    return roles.includes(roleIdentifier(role_id));
};

export const isLenderPM = (lender_id) => {
    return lender_id === "0d18a806-d6d3-11ee-b13d-00163e03550e";
};

/**
 * file downloader utility
 * we're using a href element manipulation
 * to reduce reliance on NPM libraries
 * @param {Blob} file - receives a raw blob data, directly from the API endpoint response
 * @param {String} file_name - the default file name EXCLUDING the date (we append the datetime in this method)
 * @param {String} file_type - the desired file type to be downloaded in
 * No data return, this method just initiates a file download in this format : {FILE_NAME}-{CURRENT_DATE}.{FILE_TYPE}
 */
export const fileDownloader = ({ file, file_name, file_type }) => {
    const datetime = moment().format("DD MMMM YYYY HH.mm");
    const name = `${file_name}-${datetime}.${file_type}`;
    const url = URL.createObjectURL(new Blob([file]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
    fs.writeFileSync(name, file);
    link.parentNode.removeChild(link);
};

export const access_company = () => {
    let user = store.getState().Auth.user;
      const access_user = [
        "madani.febianty@dayainspirasi.id",
        "kesuma.putra@dayainspirasi.id",
    ];
    return access_user.includes(user.email);
}
